import { render } from "./SmallPreFooter.vue?vue&type=template&id=8b31ad4a&scoped=true"
import script from "./SmallPreFooter.vue?vue&type=script&lang=js"
export * from "./SmallPreFooter.vue?vue&type=script&lang=js"

import "./SmallPreFooter.vue?vue&type=style&index=0&id=8b31ad4a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b31ad4a"]])

export default __exports__